import { useLingui } from '@lingui/react/macro';
import { Button } from 'app-ui/primitives/input';
import { AlertDialog } from 'app-ui/primitives/surfaces';
import { HotkeyLayerEffect } from '@/ui/utilities/hotkey/effect-components/HotkeyLayerEffect';
type InterventionConfirmationProps = {
  action: 'cancel' | 'delete' | null;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
};
export const InterventionConfirmation = ({
  action,
  isPending,
  onClose,
  onConfirm,
}: InterventionConfirmationProps) => {
  const { t } = useLingui();
  return (
    <AlertDialog.Root
      open={action !== null}
      onOpenChange={(open) => {
        if (!open && !isPending) onClose();
      }}
    >
      <AlertDialog.Popup>
        <HotkeyLayerEffect layer="overlay" />
        <AlertDialog.Header>
          <AlertDialog.Title>
            {action === 'cancel'
              ? t`Cancel this intervention?`
              : t`Delete this intervention?`}
          </AlertDialog.Title>
          <AlertDialog.Description>
            {action === 'cancel'
              ? t`The intervention leaves the planning board and stays in history. This action cannot be undone.`
              : t`The intervention is removed for everyone in the workspace and stays in history. This action cannot be undone.`}
          </AlertDialog.Description>
        </AlertDialog.Header>
        <AlertDialog.Footer>
          <Button
            disabled={isPending}
            onClick={onClose}
          >{t`Keep intervention`}</Button>
          <Button
            color="danger"
            variant="solid"
            loading={isPending}
            disabled={isPending}
            onClick={onConfirm}
          >
            {action === 'cancel'
              ? t`Cancel intervention`
              : t`Delete intervention`}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Popup>
    </AlertDialog.Root>
  );
};
